import React, {useState, useEffect} from 'react';
import Notify from '../Notify';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class RetrieveShift extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        startDateTime:"",
        finishDateTime:"",
        workingTime:0
    };
    this.finishOldShift = this.finishOldShift.bind(this)
    this.resumeOldShift = this.resumeOldShift.bind(this)
    this.handleFormTimeChange = this.handleFormTimeChange.bind(this);
    
  }

  handleFormTimeChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
    let startingDate = new Date(this.state.startDateTime);
    let finishDate = new Date(this.state.finishDateTime);
    
    let workingTimeResult = finishDate-startingDate;
    
    this.setState({workingTime: workingTimeResult/1000}); 
  }

   //Functions to retrieve Old Shift
   finishOldShift = async() =>{

    let shiftID = localStorage.getItem("shiftId");
    let startTime = this.state.startDateTime;
    let finishTime = this.state.finishDateTime;
    let breakTime = localStorage.getItem("timeResting");

    await this.props.finishOldShift(shiftID,startTime,finishTime,breakTime)

    this.props.close();
  }


  resumeOldShift = () =>{
    
    let startTime = new Date(this.state.startDateTime)
    let convertedStartTime = Time.convertDate(startTime);
    let breakTime = localStorage.getItem("timeResting");
    if(breakTime === null){breakTime = 0}
    const currentTime = new Date();
    const workingSeconds = (currentTime - startTime)/1000;
    
    this.props.resumeOldShift(convertedStartTime,breakTime,workingSeconds)
    this.props.close()
  }

  //When this component loads this will happen:
  componentDidMount(){

    //It will save what time is it now
    let currentTime = Time.getComputerTimeDate();
    this.setState({finishDateTime:currentTime})

    //it will get what time you started your last shift
    let localStartDateTime = localStorage.getItem("startingTime");
    this.setState({startDateTime:localStartDateTime});
    
    //calculate the total hours with what time is now minus
    //what time you started your last shift
    const currentTimeNumber = new Date(currentTime);
    const startTimeNumber = new Date(localStartDateTime);
    let workingTimeResult = currentTimeNumber-startTimeNumber;
    this.setState({workingTime:workingTimeResult/1000})

    //gets how much time you rested on your last shift
    let breakTime = localStorage.getItem("timeResting");

  }

  render() {
   
    
    let currentTime = Time.getComputerTimeDate();
    let startDateTime = localStorage.getItem("startingTime");
    let breakTime = localStorage.getItem("timeResting");

    //Get the total hours
    let totalHours;
    let startingDate = new Date(this.state.startDateTime);
    let finishDate = new Date(this.state.finishDateTime);
    totalHours = (finishDate-startingDate)/1000
    let totalHoursResult;
    if(totalHours <= 0){
        totalHoursResult = "Invalid hours try again"
    }else{
        totalHoursResult = Time.convertSecondsToString(totalHours);
    }
    return(
        <div>
            <div className='pop-up'></div>
            <div className="container pop-up-window">
                <div className="row">
                    <div className="col-12 container p-4">
                        <h3>Welcome Back, {this.props.user}!</h3>
                        <h5>We noticed you forgot to finish your last shift, so we have some options for you</h5>
                        <h6>Here is some information about your last shift:</h6>
                        <p>Break time: {Math.floor(breakTime)} minutes</p>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <label className="form-label">Start Date and Time</label>
                            <input onChange={this.handleFormTimeChange} defaultValue={startDateTime} type="datetime-local" className="form-control" id="startDateTime" required></input>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <label className="form-label">Finish Date and Time</label>
                            <input onChange={this.handleFormTimeChange} defaultValue={currentTime} type="datetime-local" className="form-control" id="finishDateTime" required></input>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <p>Total: {totalHoursResult}</p>
                        </div>
                    </div>
                    <div className="col-12 container p-4">
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button onClick={this.finishOldShift}>Finish your last shift</button>
                            <button onClick={this.resumeOldShift}>Resume your last shift</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default RetrieveShift;